module.exports = __webpack_public_path__ + "static/media/Grace Jiang.63ae6364.jpg";